import React from 'react';
import { Dialog, DialogContent, DialogTitle, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface TimeoutWarningModalProps {
  open: boolean;
  secondsRemaining: number;
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  dialog: {
    '& .MuiDialog-paper': {
      minWidth: '400px',
      textAlign: 'center',
      padding: theme.spacing(2),
    }
  },
  title: {
    paddingBottom: theme.spacing(1),
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  countdown: {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: theme.palette.error.main,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  message: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  }
}));

export const TimeoutWarningModal: React.FC<TimeoutWarningModalProps> = ({
  open,
  secondsRemaining
}) => {
  const classes = useStyles();

  // Prevent closing on backdrop click or escape key
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    // Do nothing - let user activity detection handle closing
    return;
  };

  return (
    <Dialog
      open={open}
      className={classes.dialog}
      BackdropProps={{
        className: classes.backdrop,
      }}
      onClose={handleClose}
    >
      <DialogTitle className={classes.title}>
        <Typography variant="h5" component="div">
          Session Timeout Warning
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography variant="body1" className={classes.message}>
          Your session will expire due to inactivity in:
        </Typography>
        <Box className={classes.countdown}>
          {secondsRemaining}s
        </Box>
        <Typography variant="body2" className={classes.message}>
          Click anywhere to continue your session.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};
